import { Pause, Play, RotateCcw, X, Rewind, FastForward, Volume2 } from "lucide-react";
import { useSpeech } from "@/lib/voice";
import { useAppMode } from "@/context/AppModeContext";

export default function ReadAloudBar() {
  const { speaking, paused, rate, pause, resume, replay, stop, setRate } = useSpeech();
  const { isSenior } = useAppMode();
  if (!speaking && !paused) return null;
  const big = isSenior;
  const Btn = ({ onClick, label, children, testid }) => (
    <button onClick={onClick} aria-label={label} title={label} data-testid={testid}
      className={`grid place-items-center rounded-full border border-border bg-card hover:border-primary hover:text-primary transition-colors ${big ? "h-14 w-14" : "h-10 w-10"}`}>
      {children}
    </button>
  );
  return (
    <div className={`fixed z-50 left-1/2 -translate-x-1/2 bottom-5 flex items-center gap-2 rounded-full glass border border-border shadow-xl px-3 ${big ? "py-3" : "py-2"}`} data-testid="read-aloud-bar">
      <span className={`inline-flex items-center gap-1.5 text-primary font-head font-bold ${big ? "text-base px-2" : "text-xs px-1"}`}>
        <Volume2 className={big ? "w-5 h-5" : "w-4 h-4"} />{big ? "Reading" : ""}
      </span>
      <Btn onClick={() => setRate(rate - 0.15)} label="Slower" testid="read-slower"><Rewind className={big ? "w-6 h-6" : "w-4 h-4"} /></Btn>
      <span className={`tabular-nums font-bold text-center ${big ? "w-12 text-base" : "w-9 text-xs"}`}>{rate.toFixed(1)}x</span>
      <Btn onClick={() => setRate(rate + 0.15)} label="Faster" testid="read-faster"><FastForward className={big ? "w-6 h-6" : "w-4 h-4"} /></Btn>
      {paused ? (
        <Btn onClick={resume} label="Resume" testid="read-resume"><Play className={big ? "w-6 h-6" : "w-5 h-5"} /></Btn>
      ) : (
        <Btn onClick={pause} label="Pause" testid="read-pause"><Pause className={big ? "w-6 h-6" : "w-5 h-5"} /></Btn>
      )}
      <Btn onClick={replay} label="Replay from start" testid="read-replay"><RotateCcw className={big ? "w-6 h-6" : "w-4 h-4"} /></Btn>
      <Btn onClick={stop} label="Stop" testid="read-stop"><X className={big ? "w-6 h-6" : "w-4 h-4"} /></Btn>
    </div>
  );
}
